import { put, takeLatest, select } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'

import Logger from '@Utils/Logger'
import { IAction, ISuccessResponse } from '@Root/types'

import {
  fetchAccountUsersSuccess,
  fetchAccountUsersFailure,
  createAccountUsersSuccess,
  createAccountUsersFailure,
  deleteAccountUsersSuccess,
  deleteAccountUsersFailure,
  changeRoleSuccess,
  changeRoleFailure,
  fetchAccountUsers,
} from './actions'

import {
  AccountUserActionTypes,
  IFetchAccountUsersPayload,
  IFetchAccountUsersSuccessResponseBody,
  ICreateAccountUsersPayload,
  IDeleteAccountUsersPayload,
  IChangeRolePayload,
} from './types'

import * as API from './api'

const call: any = Eff.call

function* fetchAccountUsersSaga(action: IAction<IFetchAccountUsersPayload>) {
  try {
    const response: ISuccessResponse<IFetchAccountUsersSuccessResponseBody> = yield call(API.fetchAccountUsers, action.payload)

    yield put(fetchAccountUsersSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Account users could not be loaded')
    yield put(fetchAccountUsersFailure())
  }
}

function* createAccountUsersSaga(action: IAction<ICreateAccountUsersPayload>) {
  try {
    yield call(API.createAccountUsers, action.payload)
    yield put(createAccountUsersSuccess())
    toastr.success('', 'Account users created')

    yield put(fetchAccountUsers({ accountId: action.payload.accountId }))
  } catch (e) {
    Logger.error(e, 'Account users could not be created')
    yield put(createAccountUsersFailure())
  }
}

function* deleteAccountUsersSaga(action: IAction<IDeleteAccountUsersPayload>): Generator<any, any, any> {
  try {
    yield call(API.deleteAccountUsers, action.payload)

    yield put(deleteAccountUsersSuccess(action.payload))
    toastr.success('', 'Account user(s) deleted')
  } catch (e) {
    Logger.error(e, 'Account user(s) could not be deleted')
    yield put(deleteAccountUsersFailure())
  }
}

function* changeRoleSaga(action: IAction<IChangeRolePayload>): Generator<any, any, any> {
  try {
    yield call(API.changeRole, action.payload)
    yield put(changeRoleSuccess())
    toastr.success('', 'Role changed')

    const state = yield select()
    yield put(fetchAccountUsers({ accountId: state.accounts.currentAccountId }))
  } catch (e) {
    Logger.error(e, 'Role could not be changed')
    yield put(changeRoleFailure())
  }
}

function* accountUsersSagas() {
  yield takeLatest(AccountUserActionTypes.FETCH_ACCOUNT_USERS, fetchAccountUsersSaga)
  yield takeLatest(AccountUserActionTypes.CREATE_ACCOUNT_USERS, createAccountUsersSaga)
  yield takeLatest(AccountUserActionTypes.DELETE_ACCOUNT_USERS, deleteAccountUsersSaga)
  yield takeLatest(AccountUserActionTypes.CHANGE_ROLE, changeRoleSaga)
}

export default accountUsersSagas
